import script from "./ChannelFlowSource.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelFlowSource.vue?vue&type=script&setup=true&lang=js"

import "./ChannelFlowSource.vue?vue&type=style&index=0&id=07e05514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e05514"]])

export default __exports__